const COMPOUND_INDIVIDUAL_SHOOTS_NUMBER = 6;
const COMPOUND_MIXED_TEAM_SHOOTS_NUMBER = 5;
const COMPOUND_TEAM_SHOOTS_NUMBER = 5;
const ARCHERY_H2H_SHOOTS_NUMBER = 6;
const RECURVE_MIXED_TEAM_SHOOTS_NUMBER = 5;
const RECURVE_TEAM_SHOOTS_NUMBER = 5;

export const PISTOL_H2H_SHOOT_OFF_SET_NUMBER = 2;
export const ARCHERY_H2H_SHOOT_OFF_SET_NUMBER = 6;
export const COMPOUND_ARCHERY_SHOOT_OFF_SET_BY_TYPE = {
  0: COMPOUND_INDIVIDUAL_SHOOTS_NUMBER,
  1: COMPOUND_MIXED_TEAM_SHOOTS_NUMBER,
  2: COMPOUND_TEAM_SHOOTS_NUMBER
};
export const ARCHERY_H2H_SHOOT_OFF_SET_BY_TYPE = {
  0: ARCHERY_H2H_SHOOTS_NUMBER,
  1: RECURVE_MIXED_TEAM_SHOOTS_NUMBER,
  2: RECURVE_TEAM_SHOOTS_NUMBER
};
export const PISTOL_SHOOTING_SETS_COUNT = 3;
export const ARCHERY_SHOOTING_SETS_COUNT = 6;
export const PISTOL_SHOOTING_SHOOTS_COUNT = 10;
export const ARCHERY_SHOOTING_SHOOTS_COUNT = 6;
export const H2H_COMPOUND_ARCHERY_SHOOTS_COUNT = 3;
export const PISTOL_H2H_SHOOTS_COUNT = 10;
export const PISTOL_H2H_SHOOT_OFF_MAX_SHOOTS_COUNT = 3;

export const H2H_COMPOUND_ARCHERY_MATCH_STATE_NOT_STARTED = 0;
export const H2H_COMPOUND_ARCHERY_MATCH_STATE_IN_PLAY = 1;
export const H2H_COMPOUND_ARCHERY_MATCH_STATE_TIMEOUT = 2;
export const H2H_COMPOUND_ARCHERY_MATCH_STATE_FINISHED = 3;

export const ARCHERY_H2H_GAME_STATUSES: Record<number, string> = {
  [H2H_COMPOUND_ARCHERY_MATCH_STATE_NOT_STARTED]: 'notstarted',
  [H2H_COMPOUND_ARCHERY_MATCH_STATE_IN_PLAY]: 'inplay',
  [H2H_COMPOUND_ARCHERY_MATCH_STATE_TIMEOUT]: 'timeout',
  [H2H_COMPOUND_ARCHERY_MATCH_STATE_FINISHED]: 'finished'
};
